import { render, staticRenderFns } from "./Pasos.vue?vue&type=template&id=5fc0ed93&scoped=true"
import script from "./Pasos.vue?vue&type=script&lang=js"
export * from "./Pasos.vue?vue&type=script&lang=js"
import style0 from "./Pasos.vue?vue&type=style&index=0&id=5fc0ed93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0ed93",
  null
  
)

export default component.exports